import { TechSector } from "./tech-sector";

export const hexToHsl = (hex: string): number[] => {
    var min, max, i, l, s, maxcolor, h, splitHex, rgb = [];
    if (hex.startsWith('#')) {
        splitHex = hex.substring(1).match(/.{1,2}/g) || ['00','00','00'];
    } else {
        splitHex = hex.match(/.{1,2}/g) || ['00','00','00'];
    }
    rgb[0] = Number.parseInt(splitHex[0],16) / 255;
    rgb[1] = Number.parseInt(splitHex[1],16) / 255;
    rgb[2] = Number.parseInt(splitHex[2],16) / 255;
    min = rgb[0];
    max = rgb[0];
    maxcolor = 0;
    for (i = 0; i < rgb.length - 1; i++) {
        if (rgb[i + 1] <= min) {min = rgb[i + 1];}
        if (rgb[i + 1] >= max) {max = rgb[i + 1];maxcolor = i + 1;}
    }
    if (maxcolor == 0) {
        h = (rgb[1] - rgb[2]) / (max - min);
    }
    if (maxcolor == 1) {
        h = 2 + (rgb[2] - rgb[0]) / (max - min);
    }
    if (maxcolor == 2) {
        h = 4 + (rgb[0] - rgb[1]) / (max - min);
    }
    h = h ? h : 0;
    h *= 60;
    if (h < 0) {h = h + 360; }
    l = (min + max) / 2;
    if (min == max) {
        s = 0;
    } else {
        if (l < 0.5) {
        s = (max - min) / (max + min);
        } else {
        s = (max - min) / (2 - max - min);
        }
    }
    s = s;
    return [h,s*100,l*100];
}

const theme = {
    font: 'TT Interphases,helvetica,roboto,arial,sans-serif',
    typography: {
        xs: '12px',
        sm: '14px',
        md: '20px',
        lg: '22px',
        xl: '26px',
    },
    colors: {
        primaryDark: '#09213a',
        primary: '#0e233d',
        primary80: '#0e233dcc',
        primaryLight: '#4d89ba',
        primaryLighter: '#a0d2f3',
        primaryLightContrast: '#039FE3',
        secondary: '#F78C00',
        secondaryLight: '#f18c66',
        signal: '#FF3333',
        gray1: '#cccccc',
        gray2: '#bbbbbb',
        gray3: '#575756',
        gray4: '#a8a8a8',
        white: '#ffffff',
        black: '#000000',
        // Additional UI colors
        darkBlue: '#21436f',
        darkBlue2: '#1d3f67',
        darkBlue3: '#18385d',
        darkBlue4: '#132f4e',
        darkBlue5: '#0f2640',
        tealDark: '#125f79',
        tealDarker: '#0f4561',
        lightGray: '#f1f1f1',
        mediumGray: '#e3e3e3',
        textDark: '#060606',
        sectors: {
            [TechSector.WATER]: ['#356985', '#88ACBF'],
            [TechSector.HEATING]: ['#D43539', '#2E4EB7'],
            [TechSector.WASTE_WATER]: ['#AEA137', '#D0C35E'],
            [TechSector.FIRE_PROTECTION]: ['#7F1313', '#A02122'],
        },
    },
    screens: {
        sm: '(min-width: 640px)',
        md: '(min-width: 768px)',
        lg: '(min-width: 1024px)',
    },
    zIndex: {
        base: 1,
        behind: -1,
        content: 2,
        dropdown: 100,
        overlay: 300,
        modal: 1000,
        popover: 3000,
        tooltip: 9000,
        notification: 9999,
        max: 10000,
    },
};

export default theme;